import withPage from '@lib/withPage';
import Breadcrumb from '@src/components/home/breadcrumb';
import Page from '@src/components/page';
import { decrementQty, incrementQty, removeFromCart } from '@src/redux/actions/cart';
import { getCartTotal } from '@src/services';
import Link from 'next/link';
import React from 'react';
import { connect } from 'react-redux';
const formatCurrency = require('format-currency');
import CartContent from '@src/components/checkout/Cart/CartContent';
import { setNavigation } from '@src/redux/actions';

class Cart extends Page {
	constructor(props) {
		super(props);
		this.state = {
			isQuantityLoading: false,
		};
	}

	componentDidMount() {
		const gbTrackerOrderItems = this.props.cartItems.map((prod) => {
			return {
				productId: prod.bigCommerceId,
				title: prod.name,
				price: prod.price,
				quantity: prod.qty,
				sku: prod.sku,
				category: prod.category?.id || 2
			}
		})		

		window.addEventListener('load', () => {
			gbTracker.sendOrderEvent({
				cart: {
					id: this.props.cartId,
					items: gbTrackerOrderItems
				},
			});
		});
		if (this.props.router) {
			this.props.setNavigation({ previousUrl: this.props.router.asPath });
		}
	}

	render() {
		const { cartItems, total, incrementQty, decrementQty, removeFromCart } = this.props;
		return (
			<div>
				<Breadcrumb title={'Cart Page'} />

				{cartItems.length > 0 ? (
					<div className="container">
						<div className="cart-container">
							{cartItems.map((item, index) => {
								return (
									<CartContent
										item={item}
										key={index}
										decrementQty={decrementQty}
										incrementQty={incrementQty}
										removeFromCart={removeFromCart}
										reviews={this.props.reviews}
										onQuantityChange={value => this.setState({ isQuantityLoading: value })}
									/>
								);
							})}
						</div>

						<div className="total-price-sub">
							<h3>
								Total Price: <span>${formatCurrency(total)}</span>
							</h3>
						</div>

						<div className="action-buttons">
							<div>
								<Link href={`/`} as={`/`}>
									<a className="btn btn-secondary">
										<i className="fas fa-arrow-left"></i> Continue Shopping
									</a>
								</Link>
							</div>

							<div className={`${this.state.isQuantityLoading ? 'loading' : ''}`}>
								<a href="/checkout" className={`btn btn-success ${this.state.isQuantityLoading ? 'disabled' : ''}`}>
									<i className="fas fa-shopping-cart"></i> Checkout
								</a>
							</div>
						</div>
					</div>
				) : (
					<div className="empty-alert">
						<i className="fas fa-shopping-cart fa-3x"></i>
						<h3>Your Cart is Currently Empty</h3>

						<p>Call us if your having problems.</p>
						<Link href={`/`} as={`/`}>
							<a className="btn success">Continue Shopping</a>
						</Link>
					</div>
				)}
			</div>
		);
	}
}
const mapStateToProps = state => ({
	stat: state,
	cartId: state.cartlist?.bigCommerceCart?.id || null,
	cartItems: state.cartlist.cart,
	reviews: state.reviews,
	symbol: '$',
	total: getCartTotal(state.cartlist.cart),
});

export default withPage(
	connect(mapStateToProps, {
		incrementQty,
		decrementQty,
		removeFromCart,
		setNavigation,

	})(Cart)
);
